import React, { Component } from 'react';

const defaultProps = {
  languages: null,
  headline: ''
};

class Languages extends Component {
  render() {
    const { languages, headline } = this.props;
    if (!languages.length) return <span></span>;
    return (
      <div className="languages">
        <strong>{headline}</strong>{' '}
        {languages
          .map(lang => lang.name)
          .sort()
          .join(', ')}
      </div>
    );
  }
}

Languages.defaultProps = defaultProps;

export default Languages;
